export default {
  VIEW: "view",
  ADD: "add",
  EDIT: "edit",
};
